(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-barco"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nc-barco-gallery-strip__wrap').forEach(function (wrap) {
    var strip = wrap.querySelector('.nc-barco-gallery-strip__inner');
    var prevArrow = wrap.querySelector('.nc-barco-gallery-strip__arrow--prev');
    var nextArrow = wrap.querySelector('.nc-barco-gallery-strip__arrow--next');
    if (!strip) return;

    function updateArrows() {
      var overflow = strip.scrollWidth > strip.clientWidth + 2;
      if (prevArrow) prevArrow.hidden = !overflow;
      if (nextArrow) nextArrow.hidden = !overflow;
    }

    if (prevArrow) prevArrow.addEventListener('click', function () { strip.scrollBy({ left: -320, behavior: 'smooth' }); });
    if (nextArrow) nextArrow.addEventListener('click', function () { strip.scrollBy({ left: 320, behavior: 'smooth' }); });

    updateArrows();
    window.addEventListener('resize', updateArrows);

    var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.nc-barco-gallery-strip__thumb'));
    var lightbox = document.getElementById(wrap.dataset.lightboxId);
    var lightboxImg = lightbox ? lightbox.querySelector('.nc-barco-lightbox__img') : null;
    var currentIndex = 0;

    function openLightbox(index) {
      var thumb = thumbs[index];
      if (!thumb || !lightbox || !lightboxImg) return;
      currentIndex = index;
      lightboxImg.src = thumb.dataset.fullSrc;
      lightboxImg.alt = thumb.getAttribute('aria-label') || '';
      lightbox.classList.add('nc-barco-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('nc-barco-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function step(delta) {
      if (!thumbs.length) return;
      openLightbox((currentIndex + delta + thumbs.length) % thumbs.length);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { openLightbox(i); });
    });

    if (lightbox) {
      var closeBtn = lightbox.querySelector('.nc-barco-lightbox__close');
      var prevNav = lightbox.querySelector('.nc-barco-lightbox__nav--prev');
      var nextNav = lightbox.querySelector('.nc-barco-lightbox__nav--next');
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (prevNav) prevNav.addEventListener('click', function () { step(-1); });
      if (nextNav) nextNav.addEventListener('click', function () { step(1); });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('nc-barco-lightbox__stage')) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('nc-barco-lightbox--open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') step(-1);
        if (e.key === 'ArrowRight') step(1);
      });
    }
  });

  document.querySelectorAll('.nc-barco-desc-wrap').forEach(function (wrap) {
    var desc = wrap.querySelector('.nc-barco-desc');
    var toggle = wrap.querySelector('.nc-barco-desc__toggle');
    if (!desc || !toggle) return;

    if (desc.scrollHeight > desc.clientHeight + 2) {
      toggle.hidden = false;
      toggle.textContent = toggle.dataset.readMore || toggle.textContent;
    }

    toggle.addEventListener('click', function () {
      var expanded = desc.classList.toggle('nc-barco-desc--expanded');
      toggle.textContent = expanded
        ? toggle.dataset.readLess
        : toggle.dataset.readMore;
    });
  });

  (function () {
    var modals = document.querySelectorAll('.nc-barco-modal');
    if (!modals.length) return;

    // Move modals to be direct children of <body> so `position: fixed`
    // is always relative to the viewport, even if an ancestor sets a
    // transform/filter that would otherwise break the fixed containing block.
    modals.forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });

    function openModal(modal) {
      if (!modal) return;
      modal.classList.add('nc-barco-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var firstField = modal.querySelector('input:not([type="hidden"]), textarea');
      if (firstField) firstField.focus({ preventScroll: true });
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('nc-barco-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-modal]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(document.getElementById(trigger.dataset.openModal));
      });
    });

    modals.forEach(function (modal) {
      modal.querySelectorAll('[data-modal-close]').forEach(function (closer) {
        closer.addEventListener('click', function () { closeModal(modal); });
      });

      var form = modal.querySelector('form');
      if (form) {
        form.addEventListener('submit', function () {
          try { sessionStorage.setItem('ncLastBarcoModal', modal.id); } catch (e) {}
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      modals.forEach(function (modal) {
        if (modal.classList.contains('nc-barco-modal--open')) closeModal(modal);
      });
    });

    var lastModalId;
    try { lastModalId = sessionStorage.getItem('ncLastBarcoModal'); } catch (e) {}
    if (lastModalId) {
      try { sessionStorage.removeItem('ncLastBarcoModal'); } catch (e) {}
      var lastModal = document.getElementById(lastModalId);
      if (lastModal && (lastModal.querySelector('.nc-barco-modal__success') || lastModal.querySelector('.nc-barco-modal__error'))) {
        openModal(lastModal);
      }
    }
  })();

  // Ficha técnica: paginate spec rows
  // NOTE: Liquid is not rendered inside {% javascript %}, so selectors must not
  // rely on interpolated section ids — scope through the DOM instead.
  document.querySelectorAll('.nc-barco-specs').forEach(function (specs) {
    var grid = specs.querySelector('.nc-barco-specs__grid');
    var pager = specs.querySelector('.nc-barco-specs__pager');
    if (!grid || !pager) return;

    var rows = Array.prototype.slice.call(grid.querySelectorAll('.nc-barco-spec'));
    var perPage = parseInt(grid.dataset.perPage, 10) || 10;
    if (rows.length <= perPage) return;

    var totalPages = Math.ceil(rows.length / perPage);
    var page = 0;
    var prev = pager.querySelector('[data-specs-prev]');
    var next = pager.querySelector('[data-specs-next]');
    var status = pager.querySelector('[data-specs-status]');

    function render() {
      var start = page * perPage;
      var end = start + perPage;
      rows.forEach(function (row, i) {
        row.hidden = i < start || i >= end;
      });
      if (status) status.textContent = (page + 1) + ' / ' + totalPages;
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page >= totalPages - 1;
    }

    if (prev) prev.addEventListener('click', function () { if (page > 0) { page--; render(); } });
    if (next) next.addEventListener('click', function () { if (page < totalPages - 1) { page++; render(); } });

    pager.hidden = false;
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-recambio"] && !Shopify.designMode) return;
  try {
    
  // NOTE: Liquid is not rendered inside {% javascript %}, so selectors must not
  // rely on interpolated section ids — scope through the DOM instead.

  // Thumbnail gallery
  document.querySelectorAll('.nc-rec-gallery').forEach(function (gallery) {
    gallery.querySelectorAll('.nc-rec-gallery__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const targetId = this.dataset.target;
        gallery.querySelectorAll('.nc-rec-gallery__slide').forEach(function(s) {
          s.classList.remove('nc-rec-gallery__slide--active');
        });
        gallery.querySelectorAll('.nc-rec-gallery__thumb').forEach(function(t) {
          t.classList.remove('nc-rec-gallery__thumb--active');
        });
        const target = document.getElementById(targetId);
        if (target) target.classList.add('nc-rec-gallery__slide--active');
        this.classList.add('nc-rec-gallery__thumb--active');
      });
    });
  });

  // Qty stepper
  document.querySelectorAll('.nc-qty-stepper').forEach(function (stepper) {
    const qtyInput = stepper.querySelector('.nc-qty-stepper__input');
    if (!qtyInput) return;
    stepper.querySelectorAll('.nc-qty-stepper__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const current = parseInt(qtyInput.value, 10) || 1;
        if (this.dataset.action === 'plus') {
          qtyInput.value = current + 1;
        } else if (this.dataset.action === 'minus' && current > 1) {
          qtyInput.value = current - 1;
        }
      });
    });
  });

  // "Comprar ahora": add to cart, then go straight to checkout
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var returnTo = form.querySelector('[data-return-to]');
      if (returnTo) returnTo.value = '/checkout';
    });
  });

  // Variant pills
  document.querySelectorAll('.nc-variant-pill[data-url]').forEach(function(pill) {
    pill.addEventListener('click', function() {
      window.location = this.dataset.url;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-boats-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nc-boats-accordion').forEach(function (accordion) {
    var panels = Array.prototype.slice.call(accordion.querySelectorAll('.nc-boats-panel'));

    panels.forEach(function (panel) {
      var toggle = panel.querySelector('.nc-boats-panel__toggle');
      var content = panel.querySelector('.nc-boats-panel__content');
      if (!toggle || !content) return;

      toggle.addEventListener('click', function () {
        var isOpen = panel.classList.contains('nc-boats-panel--open');

        panels.forEach(function (other) {
          other.classList.remove('nc-boats-panel--open');
          var otherToggle = other.querySelector('.nc-boats-panel__toggle');
          var otherContent = other.querySelector('.nc-boats-panel__content');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          if (otherContent) otherContent.hidden = true;
        });

        if (!isOpen) {
          panel.classList.add('nc-boats-panel--open');
          toggle.setAttribute('aria-expanded', 'true');
          content.hidden = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-cart-redirect"]) return;
  try {
    
  (function () {
    // Remove /cart from history so Back doesn't bounce the visitor here again.
    var target = document.referrer && document.referrer.indexOf(window.location.host) !== -1
      ? document.referrer
      : window.location.origin + '/';

    try {
      sessionStorage.setItem('ncOpenCartDrawer', '1');
    } catch (e) {}

    window.location.replace(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-category-search"] && !Shopify.designMode) return;
  try {
    
  // NOTE: Liquid is not rendered inside {% javascript %}, so selectors must not
  // rely on interpolated section ids — scope through the DOM instead.
  document.querySelectorAll('.nc-search-bar').forEach(function (bar) {
    var form = bar.querySelector('.nc-search-bar__form');
    var input = bar.querySelector('.nc-search-bar__input');
    var emptyMsg = bar.querySelector('.nc-search-bar__empty');
    if (!input || !form) return;

    var debounceTimer;

    function filterCards() {
      var query = input.value.trim().toLowerCase();
      var cards = document.querySelectorAll('.nc-rec-card');
      if (!cards.length) return;

      var visibleCount = 0;
      cards.forEach(function (card) {
        var nameEl = card.querySelector('.nc-rec-card__name');
        var name = nameEl ? nameEl.textContent.toLowerCase() : '';
        var match = query === '' || name.indexOf(query) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) visibleCount += 1;
      });

      if (emptyMsg) emptyMsg.hidden = !(query !== '' && visibleCount === 0);
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(filterCards, 120);
    });

    form.addEventListener('submit', function (e) {
      if (input.value.trim() === '') e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-collection-recambios-grid"] && !Shopify.designMode) return;
  try {
    
  // Dawn collapses each facet group by default, which makes the tag filter look
  // like it isn't there. Expand every group on load (the outer .nc-rec-filters
  // toggle still controls the whole sidebar on mobile).
  (function () {
    var content = document.querySelector('.nc-rec-filters__content');
    if (!content) return;
    content.querySelectorAll('details').forEach(function (d) { d.open = true; });
  })();

  (function () {
    var filters = document.querySelector('.nc-rec-filters');
    if (!filters) return;

    var mq = window.matchMedia('(max-width: 989px)');
    var userToggled = false;

    filters.addEventListener('toggle', function () {
      // Once the visitor decides, stop auto-managing on resize
      if (mq.matches) userToggled = true;
    });

    function sync() {
      if (userToggled) return;
      filters.open = !mq.matches;
    }

    sync();
    if (mq.addEventListener) {
      mq.addEventListener('change', function () { userToggled = false; sync(); });
    } else if (mq.addListener) {
      mq.addListener(function () { userToggled = false; sync(); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('nc-hero-section')) return;

    var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return ESC[c]; }); };

    class NcHeroSection extends HTMLElement {
      connectedCallback() {
        if (this._init) { this.startLoop(); return; }
        this._init = true;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Movimiento reducido: el vídeo se queda en su fotograma de portada.
        if (this.reduced) {
          this.querySelectorAll('.nc-hero__media--video video').forEach(function (v) {
            v.removeAttribute('autoplay');
            v.pause();
          });
        }

        this.raiseHeader();
        this.initSlides();
        this.initSearch();
        this.initChips();
      }

      /* La cabecera del tema (y sus menús desplegables) siempre por encima del hero.
         Solo actúa si la cabecera no tiene ya una capa propia suficiente. */
      raiseHeader() {
        var els = Array.from(document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-header'));
        var header = document.querySelector('header');
        var wrap = header && header.closest('.shopify-section');
        if (wrap && els.indexOf(wrap) === -1) els.push(wrap);
        els.forEach(function (el) {
          if (el.contains(this)) return;
          var cs = window.getComputedStyle(el);
          if (cs.position === 'static') el.style.position = 'relative';
          var z = parseInt(cs.zIndex, 10);
          if (isNaN(z) || z < 4) el.style.zIndex = '4';
        }, this);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      /* ---------- Imágenes de fondo ---------- */
      initSlides() {
        var self = this;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.spots = Array.from(this.querySelectorAll('[data-spot]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
        this.pauseBtn = this.querySelector('[data-pause]');
        this.index = 0;
        this.elapsed = 0;
        this.duration = parseInt(this.dataset.autoplaySpeed, 10) || 6000;
        this.holds = new Set();
        if (this.slides.length < 2) return;

        if (this.dataset.autoplay !== 'true') {
          this.holds.add('noauto');
          this.classList.add('no-autoplay', 'is-held');
        } else if (this.reduced) {
          this.setUserPaused(true);
        }

        this.dots.forEach(function (dot) {
          dot.addEventListener('click', function () { self.show(Number(dot.dataset.dotIndex)); });
        });
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', function () { self.setUserPaused(!self.holds.has('user')); });
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            self.hold('offscreen', !entries[0].isIntersecting);
          }).observe(this);
        }
        document.addEventListener('visibilitychange', function () { self.hold('hidden', document.hidden); });

        // En el editor de Shopify, al seleccionar una diapositiva se muestra y se queda quieta.
        this.addEventListener('shopify:block:select', function (e) {
          var i = self.slides.indexOf(e.target);
          if (i > -1) { self.show(i); self.hold('editor', true); }
        });
        this.addEventListener('shopify:block:deselect', function () { self.hold('editor', false); });

        this.tick = this.tick.bind(this);
        this.startLoop();
      }

      startLoop() {
        if (!this.slides || this.slides.length < 2 || this.raf) return;
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.tick);
      }

      tick(now) {
        var dt = Math.min(now - this.last, 100);
        this.last = now;
        if (!this.holds.size) {
          this.elapsed += dt;
          if (this.elapsed >= this.duration) this.show(this.index + 1);
        }
        var dot = this.dots[this.index];
        var p = Math.min(this.elapsed / this.duration, 1);
        if (dot && dot._p !== p) { dot._p = p; dot.style.setProperty('--p', p.toFixed(4)); }
        this.raf = requestAnimationFrame(this.tick);
      }

      hold(key, on) {
        if (on) this.holds.add(key); else this.holds.delete(key);
        this.classList.toggle('is-held', this.holds.size > 0);
      }

      setUserPaused(paused) {
        this.hold('user', paused);
        this.classList.toggle('is-user-paused', paused);
        if (this.pauseBtn) {
          this.pauseBtn.setAttribute('aria-pressed', String(paused));
          this.pauseBtn.setAttribute('aria-label', paused ? 'Reanudar el cambio de imágenes' : 'Pausar el cambio de imágenes');
        }
      }

      show(i) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        this.elapsed = 0;
        if (i === this.index) return;

        var prev = this.slides[this.index];
        var next = this.slides[i];
        prev.classList.remove('nc-hero__slide--active');
        prev.classList.add('is-leaving');
        clearTimeout(prev._t);
        prev._t = setTimeout(function () { prev.classList.remove('is-leaving'); }, 1500);
        clearTimeout(next._t);
        next.classList.remove('is-leaving');
        next.classList.add('nc-hero__slide--active');

        var oldDot = this.dots[this.index];
        if (oldDot) {
          oldDot._p = 0;
          oldDot.style.setProperty('--p', 0);
          oldDot.classList.remove('nc-hero__dot--active');
          oldDot.removeAttribute('aria-current');
        }
        if (this.dots[i]) {
          this.dots[i].classList.add('nc-hero__dot--active');
          this.dots[i].setAttribute('aria-current', 'true');
        }

        var target = String(i);
        var hasMatch = this.spots.some(function (sp) { return sp.dataset.spot === target; });
        this.spots.forEach(function (sp) {
          var on = hasMatch && sp.dataset.spot === target;
          sp.classList.toggle('is-active', on);
          if (on) { sp.removeAttribute('aria-hidden'); sp.removeAttribute('tabindex'); }
          else { sp.setAttribute('aria-hidden', 'true'); sp.setAttribute('tabindex', '-1'); }
        });

        this.index = i;
      }

      /* ---------- Búsquedas populares en móvil: carrusel lento y arrastrable ---------- */
      initChips() {
        var self = this;
        var vp = this.querySelector('[data-chips]');
        if (!vp) return;
        var list = vp.querySelector('ul');
        var originals = Array.from(list.children);
        if (!originals.length) return;
        var mq = window.matchMedia('(max-width: 749px)');
        var speed = 22; // píxeles por segundo
        var c = { on: false, pos: 0, vel: 0, setW: 1, drag: null, resumeAt: 0, hold: false, suppress: false, vw: 0 };
        this.chips = c;

        var mod = function (n, m) { return ((n % m) + m) % m; };
        var render = function () { list.style.transform = 'translate3d(' + (-c.pos).toFixed(2) + 'px,0,0)'; };

        var setup = function () {
          list.querySelectorAll('[data-clone]').forEach(function (n) { n.remove(); });
          list.style.transform = '';
          vp.classList.remove('is-moving');
          c.on = false;
          c.vw = vp.clientWidth;
          // Fuera del móvil, con movimiento reducido o si caben todas, se quedan quietas.
          if (!mq.matches || self.reduced) return;
          if (list.scrollWidth <= vp.clientWidth + 1) return;
          var frag = document.createDocumentFragment();
          originals.forEach(function (li) {
            var clone = li.cloneNode(true);
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
            frag.appendChild(clone);
          });
          list.appendChild(frag);
          var firstClone = list.querySelector('[data-clone]');
          c.setW = firstClone.offsetLeft - originals[0].offsetLeft;
          vp.scrollLeft = 0;
          vp.classList.add('is-moving');
          c.pos = mod(c.pos, c.setW);
          c.on = true;
          render();
        };

        var last = performance.now();
        var tick = function (now) {
          var dt = Math.min(now - last, 64) / 1000;
          last = now;
          if (c.on && !(c.drag && c.drag.moved)) {
            var goal = (!c.hold && now >= c.resumeAt) ? speed : 0;
            c.vel += (goal - c.vel) * Math.min(1, dt * 2.5);
            if (goal === 0 && Math.abs(c.vel) < .05) c.vel = 0;
            if (c.vel) { c.pos = mod(c.pos + c.vel * dt, c.setW); render(); }
          }
          requestAnimationFrame(tick);
        };

        vp.addEventListener('pointerdown', function (e) {
          if (!c.on || (e.pointerType === 'mouse' && e.button !== 0)) return;
          c.drag = { x: e.clientX, start: c.pos, id: e.pointerId, moved: false };
        });
        vp.addEventListener('pointermove', function (e) {
          var d = c.drag;
          if (!d || e.pointerId !== d.id) return;
          var dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 6) return;
            d.moved = true;
            d.x = e.clientX;
            d.start = c.pos;
            dx = 0;
            c.vel = 0;
            vp.classList.add('is-dragging');
            try { vp.setPointerCapture(d.id); } catch (_) {}
          }
          c.pos = mod(d.start - dx, c.setW);
          render();
        });
        var end = function (e) {
          var d = c.drag;
          if (!d || e.pointerId !== d.id) return;
          c.drag = null;
          if (d.moved) {
            vp.classList.remove('is-dragging');
            c.suppress = true;
            setTimeout(function () { c.suppress = false; }, 60);
            c.resumeAt = performance.now() + 2500;
          }
        };
        vp.addEventListener('pointerup', end);
        vp.addEventListener('pointercancel', end);
        vp.addEventListener('click', function (e) {
          if (c.suppress) { e.preventDefault(); e.stopPropagation(); }
        }, true);
        vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
        vp.addEventListener('focusin', function () { c.hold = true; });
        vp.addEventListener('focusout', function () { c.hold = false; });

        if (mq.addEventListener) mq.addEventListener('change', setup); else if (mq.addListener) mq.addListener(setup);
        if ('ResizeObserver' in window) {
          new ResizeObserver(function () { if (vp.clientWidth !== c.vw) setup(); }).observe(vp);
        }
        setup();
        requestAnimationFrame(tick);
      }

      /* ---------- Buscador ---------- */
      initSearch() {
        var self = this;
        var form = this.querySelector('[data-search]');
        if (!form) return;
        this.form = form;
        this.input = form.querySelector('input[name="q"]');
        this.drop = form.querySelector('[data-drop]');
        this.list = form.querySelector('[data-list]');
        this.status = form.querySelector('[data-drop-status]');
        this.live = form.querySelector('[data-live]');
        this.ph = form.querySelector('[data-ph]');
        this.options = [];
        this.active = -1;

        var syncValue = function () { form.classList.toggle('has-value', !!self.input.value); };
        syncValue();
        this.input.addEventListener('input', syncValue);

        // Mientras el cliente busca, el fondo no cambia.
        form.addEventListener('focusin', function () { self.hold('search', true); });
        form.addEventListener('focusout', function (e) {
          if (form.contains(e.relatedTarget)) return;
          self.hold('search', false);
          self.close();
        });

        this.initPlaceholder();
        if (this.dataset.predictive === 'true' && this.drop) this.initPredictive();
      }

      initPlaceholder() {
        var self = this;
        var examples = (this.dataset.examples || '').split(/\r?\n/).map(function (t) { return t.trim(); }).filter(Boolean);
        if (!this.ph || !examples.length || this.reduced) return;

        var base = this.input.getAttribute('placeholder') || '';
        var prefix = this.dataset.examplePrefix || '';
        var seq = [base].concat(examples.map(function (t) { return prefix + t; }));
        var k = 0;

        this.input.setAttribute('placeholder', '');
        this.ph.textContent = base;
        this.form.classList.add('has-ph');

        setInterval(function () {
          if (self.input.value || document.hidden) return;
          self.ph.classList.add('is-out');
          setTimeout(function () {
            k = (k + 1) % seq.length;
            self.ph.textContent = seq[k];
            self.ph.classList.remove('is-out');
          }, 260);
        }, 3400);
      }

      initPredictive() {
        var self = this;
        var timer;

        this.input.addEventListener('input', function () {
          clearTimeout(timer);
          var q = self.input.value.trim();
          if (q.length < 2) { self.abort(); self.close(); self.lastQ = ''; return; }
          timer = setTimeout(function () { self.fetchResults(q); }, 220);
        });

        this.input.addEventListener('focus', function () {
          if (self.lastQ && self.lastQ === self.input.value.trim()) self.open();
        });

        this.input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            if (self.isOpen) { e.preventDefault(); self.close(); }
            return;
          }
          if (!self.isOpen || !self.options.length) return;
          if (e.key === 'ArrowDown') { e.preventDefault(); self.move(1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); self.move(-1); }
          else if (e.key === 'Enter' && self.active > -1) {
            var link = self.options[self.active].querySelector('a');
            if (link) { e.preventDefault(); window.location.href = link.href; }
          }
        });

        this.list.addEventListener('mousemove', function (e) {
          var opt = e.target.closest('[role="option"]');
          if (!opt) return;
          var i = self.options.indexOf(opt);
          if (i !== self.active) self.setActive(i, true);
        });

        document.addEventListener('click', function (e) {
          if (self.isOpen && !self.form.contains(e.target)) self.close();
        });
      }

      abort() {
        if (this.ctrl) { this.ctrl.abort(); this.ctrl = null; }
      }

      fetchResults(q) {
        var self = this;
        this.abort();
        var ctrl = this.ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;

        var params = new URLSearchParams();
        params.set('q', q);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '6');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.sku,variants.title,vendor,tag');

        fetch(this.dataset.psUrl + '.json?' + params.toString(), {
          headers: { 'Accept': 'application/json' },
          signal: ctrl ? ctrl.signal : undefined
        })
          .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
          .then(function (data) {
            if (q !== self.input.value.trim()) return;
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            self.render(q, products);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            self.close();
          });
      }

      highlight(title, q) {
        var t = String(title || '');
        var i = t.toLowerCase().indexOf(q.toLowerCase());
        if (i < 0 || !q) return esc(t);
        return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + q.length)) + '</mark>' + esc(t.slice(i + q.length));
      }

      money(value) {
        var n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
        if (isNaN(n)) return '';
        if (n === 0) return this.dataset.labelPriceZero || '';
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'es', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(n);
        } catch (e) {
          return n.toFixed(2);
        }
      }

      thumb(url) {
        if (!url) return '';
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }

      render(q, products) {
        var self = this;
        var base = this.list.id;
        var html = products.map(function (p, i) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var stock = p.available
            ? '<span class="nc-hero__res-stock is-in">' + esc(self.dataset.labelIn) + '</span>'
            : '<span class="nc-hero__res-stock is-order">' + esc(self.dataset.labelOrder) + '</span>';
          return '<li class="nc-hero__res" role="option" id="' + base + '-' + i + '" aria-selected="false">' +
            '<a class="nc-hero__res-link" href="' + esc(p.url) + '" tabindex="-1">' +
              '<span class="nc-hero__res-thumb">' + (img ? '<img src="' + esc(self.thumb(img)) + '" alt="" width="52" height="52" loading="lazy">' : '') + '</span>' +
              '<span class="nc-hero__res-meta">' +
                (p.vendor ? '<span class="nc-hero__res-vendor">' + esc(p.vendor) + '</span>' : '') +
                '<span class="nc-hero__res-title">' + self.highlight(p.title, q) + '</span>' +
              '</span>' +
              '<span class="nc-hero__res-side"><span class="nc-hero__res-price">' + esc(self.money(p.price)) + '</span>' + stock + '</span>' +
            '</a></li>';
        }).join('');

        var allUrl = this.dataset.searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
        if (products.length) {
          html += '<li class="nc-hero__res nc-hero__res--all" role="option" id="' + base + '-all" aria-selected="false">' +
            '<a class="nc-hero__res-link" href="' + esc(allUrl) + '" tabindex="-1">' + esc(this.dataset.labelAll) + ' «' + esc(q) + '» <span aria-hidden="true">→</span></a></li>';
        }

        this.list.innerHTML = html;
        this.options = Array.from(this.list.querySelectorAll('[role="option"]'));
        this.status.textContent = products.length ? '' : (this.dataset.labelEmpty || '').replace('{q}', q);
        this.setActive(-1);
        this.lastQ = q;
        this.open();
        if (this.live) {
          this.live.textContent = products.length
            ? (this.dataset.labelCount || '').replace('{n}', products.length)
            : this.status.textContent;
        }
      }

      move(d) {
        var n = this.options.length;
        var i = this.active + d;
        if (i < -1) i = n - 1;
        if (i >= n) i = -1;
        this.setActive(i);
      }

      setActive(i, fromMouse) {
        this.active = i;
        this.options.forEach(function (opt, k) { opt.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        if (i > -1) {
          this.input.setAttribute('aria-activedescendant', this.options[i].id);
          if (!fromMouse) this.options[i].scrollIntoView({ block: 'nearest' });
        } else {
          this.input.removeAttribute('aria-activedescendant');
        }
      }

      open() {
        if (!this.drop || (!this.options.length && !this.status.textContent)) return;
        this.drop.hidden = false;
        this.isOpen = true;
        this.classList.add('is-searching');
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (!this.drop) return;
        this.drop.hidden = true;
        this.isOpen = false;
        this.classList.remove('is-searching');
        if (this.input) {
          this.input.setAttribute('aria-expanded', 'false');
          this.input.removeAttribute('aria-activedescendant');
        }
        this.active = -1;
      }
    }

    customElements.define('nc-hero-section', NcHeroSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('nc-works-section')) return;

    class NcWorksSection extends HTMLElement {
      connectedCallback() {
        if (this._init) { this.startMesh(); return; }
        this._init = true;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.raiseHeader();
        this.initMesh();
        this.initViewer();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }

      /* La cabecera del tema y sus menús siempre por encima de la sección */
      raiseHeader() {
        var els = Array.from(document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-header'));
        var header = document.querySelector('header');
        var wrap = header && header.closest('.shopify-section');
        if (wrap && els.indexOf(wrap) === -1) els.push(wrap);
        els.forEach(function (el) {
          if (el.contains(this)) return;
          var cs = window.getComputedStyle(el);
          if (cs.position === 'static') el.style.position = 'relative';
          var z = parseInt(cs.zIndex, 10);
          if (isNaN(z) || z < 4) el.style.zIndex = '4';
        }, this);
      }

      /* ---------- Malla técnica: superficie de mar en wireframe ---------- */
      initMesh() {
        var self = this;
        this.canvas = this.querySelector('[data-mesh-canvas]');
        if (!this.canvas || !this.canvas.getContext) return;
        this.ctx = this.canvas.getContext('2d');
        this.intensity = parseFloat(this.dataset.intensity) || .6;
        this.animated = this.dataset.mesh === 'true' && !this.reduced;
        this.visible = true;
        this.camX = 0;
        this.targetX = 0;
        this.last = 0;

        this.resize = this.resize.bind(this);
        this.frame = this.frame.bind(this);
        this.resize();

        if ('ResizeObserver' in window) new ResizeObserver(this.resize).observe(this);
        else window.addEventListener('resize', this.resize);

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            self.visible = entries[0].isIntersecting;
            if (self.visible) self.startMesh();
          }).observe(this);
        }

        // Ligero paralaje con el ratón (solo escritorio)
        if (window.matchMedia('(hover: hover)').matches) {
          this.addEventListener('pointermove', function (e) {
            var r = self.getBoundingClientRect();
            self.targetX = ((e.clientX - r.left) / r.width - .5) * .5;
          });
          this.addEventListener('pointerleave', function () { self.targetX = 0; });
        }

        if (this.animated) this.startMesh();
        else this.draw(12);
      }

      resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var w = this.clientWidth, h = this.clientHeight;
        if (!w || !h) return;
        this.w = w; this.h = h;
        this.canvas.width = Math.round(w * dpr);
        this.canvas.height = Math.round(h * dpr);
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (!this.animated) this.draw(12);
      }

      startMesh() {
        if (!this.animated || this.raf || !this.ctx) return;
        this.raf = requestAnimationFrame(this.frame);
      }

      frame(now) {
        this.raf = null;
        if (!this.visible || document.hidden) return;
        // ~30 fps: suficiente para un movimiento lento y ahorra batería
        if (now - this.last >= 33) {
          this.last = now;
          this.camX += (this.targetX - this.camX) * .05;
          this.draw(now / 1000);
        }
        this.raf = requestAnimationFrame(this.frame);
      }

      draw(t) {
        var ctx = this.ctx, W = this.w, H = this.h;
        if (!ctx || !W) return;
        ctx.clearRect(0, 0, W, H);

        var mobile = W < 750;
        var cols = mobile ? 26 : 46;
        var rows = mobile ? 20 : 26;
        var zNear = 1, zFar = 7.5;
        var f = Math.max(W, H * 1.1) * .62;
        var horizon = H * (mobile ? .3 : .34);
        var camY = 1.25;
        var k = this.intensity;
        var pts = [];
        var r, c;

        for (r = 0; r < rows; r++) {
          var z = zNear + (zFar - zNear) * Math.pow(r / (rows - 1), 1.15);
          var span = (W / 2) / f * z * 1.25 + .3;
          var row = [];
          for (c = 0; c < cols; c++) {
            var x = (c / (cols - 1) * 2 - 1) * span;
            var y = Math.sin(x * 1.15 + t * .45) * .16
                  + Math.sin(z * 1.6 - t * .6) * .12
                  + Math.sin((x * .7 + z) * 1.3 + t * .3) * .08;
            row.push([
              W / 2 + (x - this.camX) / z * f,
              horizon + (camY - y) / z * f * .55
            ]);
          }
          pts.push(row);
        }

        ctx.lineWidth = 1;
        for (r = 0; r < rows; r++) {
          var fade = Math.pow(1 - r / (rows - 1), 1.4);
          var a = (.03 + .2 * fade) * k;
          ctx.strokeStyle = 'rgba(255,255,255,' + a.toFixed(3) + ')';
          ctx.beginPath();
          // Línea horizontal (a lo ancho)
          for (c = 0; c < cols; c++) {
            if (c === 0) ctx.moveTo(pts[r][c][0], pts[r][c][1]);
            else ctx.lineTo(pts[r][c][0], pts[r][c][1]);
          }
          // Segmentos hacia la fila siguiente (en profundidad)
          if (r < rows - 1) {
            for (c = 0; c < cols; c++) {
              ctx.moveTo(pts[r][c][0], pts[r][c][1]);
              ctx.lineTo(pts[r + 1][c][0], pts[r + 1][c][1]);
            }
          }
          ctx.stroke();

          // Nodos: pequeños cuadrados en algunos vértices
          if (r % 3 === 0) {
            ctx.fillStyle = 'rgba(255,255,255,' + Math.min(a * 2.2, .55).toFixed(3) + ')';
            for (c = r % 2; c < cols; c += 5) {
              ctx.fillRect(pts[r][c][0] - 1.5, pts[r][c][1] - 1.5, 3, 3);
            }
          }
        }
      }

      /* ---------- Visor 3D ---------- */
      initViewer() {
        var self = this;
        var mv = this.querySelector('[data-viewer]');
        if (!mv) return;
        this.mv = mv;
        // En pantallas estrechas, algo más de margen para que el barco no roce los bordes al girar
        if (window.matchMedia('(max-width: 749px)').matches) mv.setAttribute('camera-orbit', '35deg 72deg 100%');
        var bar = this.querySelector('[data-progress]');
        var status = this.querySelector('[data-status]');
        var hint = this.querySelector('[data-hint]');

        // Carga el script del visor solo cuando la sección está cerca de verse
        var load = function () {
          if (customElements.get('model-viewer')) return self.afterViewerDefined();
          if (!document.querySelector('script[data-ncw-mv]')) {
            var sc = document.createElement('script');
            sc.type = 'module';
            sc.src = self.dataset.mvSrc;
            sc.setAttribute('data-ncw-mv', '');
            document.head.appendChild(sc);
          }
          customElements.whenDefined('model-viewer').then(function () { self.afterViewerDefined(); });
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) { io.disconnect(); load(); }
          }, { rootMargin: '600px 0px' });
          io.observe(this);
        } else {
          load();
        }

        mv.addEventListener('progress', function (e) {
          var p = e.detail && e.detail.totalProgress || 0;
          if (bar) {
            bar.style.width = Math.round(p * 100) + '%';
            bar.parentNode.classList.toggle('is-done', p >= 1);
          }
        });
        mv.addEventListener('load', function () {
          if (status) status.hidden = true;
          if (bar) bar.parentNode.classList.add('is-done');
        });
        mv.addEventListener('error', function () {
          if (status) status.hidden = false;
          if (bar) bar.parentNode.classList.add('is-done');
        });
        mv.addEventListener('camera-change', function (e) {
          if (hint && e.detail && e.detail.source === 'user-interaction') hint.classList.add('is-hidden');
        });

        // Selector de versión
        var tabs = Array.from(this.querySelectorAll('.ncw__tab'));
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            if (tab.classList.contains('is-active')) return;
            tabs.forEach(function (t) {
              var on = t === tab;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            if (bar) { bar.style.width = '0%'; bar.parentNode.classList.remove('is-done'); }
            if (tab.dataset.ios) mv.setAttribute('ios-src', tab.dataset.ios);
            else mv.removeAttribute('ios-src');
            mv.setAttribute('alt', (mv.getAttribute('alt') || '').split(' · ')[0] + ' · ' + tab.dataset.label);
            mv.src = tab.dataset.src;
          });
        });
      }

      afterViewerDefined() {
        if (this.reduced && this.mv) this.mv.removeAttribute('auto-rotate');
      }
    }

    customElements.define('nc-works-section', NcWorksSection);
  })();

  } catch(e) { console.error(e); }
})();
})();
